import { render, staticRenderFns } from "./showSale.vue?vue&type=template&id=89a620c2&scoped=true&"
import script from "./showSale.vue?vue&type=script&lang=js&"
export * from "./showSale.vue?vue&type=script&lang=js&"
import style0 from "./showSale.vue?vue&type=style&index=0&id=89a620c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a620c2",
  null
  
)

export default component.exports